<template>
  <qx-card-form title="基础信息">
    <span slot="titleLeft">
      <span class="applyInfoLabel">（申请人：</span>
      <span class="primary">{{ userInfo.staffTFInfo && userInfo.staffTFInfo.linkman }}</span>
      <span class="applyInfoLabel">申请时间：</span>
      <span class="primary">{{ applyTime }}</span>
      <template v-if="busiCode">
        <span class="applyInfoLabel">申请单号：</span>
        <span class="primary">{{ busiCode }}</span>
      </template>
      ）
    </span>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="servicer" slot-scope="prop">
        <template v-if="Number(prop.form.costType) === 2020">
          <ChooseSite
            :isRadio="true"
            customShowName="serviceName"
            v-model="prop.form.servicer"
            @change="sendDataToReceipt"
          />
        </template>
        <template v-else>
          <ChooseServicer
            :isRadio="true"
            v-model="prop.form.servicer"
            :otherSearchData="{ serviceType }"
            ref="chooseAnnualFee"
            @change="sendDataToReceipt"
          />
        </template>
      </section>
      <section slot="car" slot-scope="prop">
        <ChooseCar
          :isRadio="true"
          v-model="prop.form.car"
          :otherSearchData="{
              orgId: prop.form.orgId,
            }"
          @change="handleCommonChange"
        />
      </section>
      <section slot="driver" slot-scope="prop">
        <ChooseDriver :isRadio="true" v-model="prop.form.driver" @change="handleCommonChange" />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  mapState,
} from 'vuex';
import {
  getDepartmentAllList,
} from 'api';
import {
  queryVehicleExpenseTypes,
} from 'api/cost';
// import {
//   getPreOrNextToday,
// } from '@qx/utils/index';
import ChooseSite from 'components/choose/site';
import ChooseServicer from 'components/choose/servicer';
import ChooseCar from 'components/choose/car';
import ChooseDriver from 'components/choose/driver';
export default {
  components: {
    ChooseServicer,
    ChooseSite,
    ChooseCar,
    ChooseDriver,
  },
  data () {
    return {
      serviceType: '',
      applyTime: '',
      busiCode: '',
      baseForm: {
        costTypeOptions: [], // 费用类型
        orgIdOptions: [],
        form: [
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
            hide: true,
          },
          {
            label: '费用类型',
            value: 'costType',
            type: 'select',
            // type: 'cascader',
            // normal: true,
            // default: [-1],
            placeholder: '请选择费用类型',
            onChange: () => {
              this.handleCostTypeChange(true);
            },
            hide: false,
          },
          {
            label: '车辆归属',
            value: 'orgId',
            type: 'select',
            onChange: () => {
              this.sendDataToAccident();
              this.sendDataToDetail();
            },
          },
          {
            label: '司机姓名',
            value: 'driver',
            slot: true,
            default: {},
            hide: true,
          },
          {
            label: '是否开票',
            value: 'isNeedBill',
            type: 'select',
            options: [
              {
                label: '否',
                value: 0,
              },
              {
                label: '是',
                value: 1,
              },
            ],
          },
          {
            label: '选择服务商',
            value: 'chooseServerType',
            type: 'radio',
            default: 1,
            options: [
              {
                label: '已有服务商',
                value: 1,
              },
              {
                label: '自定义输入',
                value: 0,
              },
            ],
            hide: true,
            onChange: () => {
              this.handleChooseServerTypeChange(true);
            },
          },
          {
            label: '服务商',
            value: 'servicer',
            default: {},
            slot: true,
            hide: true,
          },
          {
            label: '服务商名称',
            value: 'serviceName',
            type: 'input',
            hide: true,
          },
          // {
          //   label: '申请金额',
          //   value: '',
          //   type: 'input',
          // },
          // {
          //   label: '费用归属日期',
          //   value: 'feeAscriptionDate',
          //   type: 'date',
          //   default: '',
          //   attr: {
          //     time: '00:00:00',
          //   },
          // },
        ],
        rules: {
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          driver: [ // 司机姓名
            { required: true, message: '请选择司机姓名', trigger: 'blur' },
          ],
          costType: [ // 费用类型
            { required: true, message: '请选择费用类型', trigger: 'blur' },
          ],
          orgId: [ // 车辆归属
            { required: true, message: '请选择费用归属', trigger: 'blur' },
          ],
          isNeedBill: [ // 是否开票
            { required: true, message: '请选择是否开票', trigger: 'blur' },
          ],
          servicer: [ // 服务商
            { required: true, message: '请选择服务商', trigger: 'blur' },
          ],
          // payAmt: [ // 申请金额
          //   { required: true, message: '请输入申请金额', trigger: 'blur' },
          // ],
          // purchaseFee: [ // 采购金额
          //   { required: true, message: '请输入采购金额', trigger: 'blur' },
          // ],
          // feeAscriptionDate: [ // 费用归属日期
          //   { required: true, message: '请选择费用归属日期', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    // 详情也需要本页面表单的值
    handleCommonChange () {
      this.sendDataToDetail();
    },
    async sendDataToAccident () {
      await this.$emit('getOtherFormVal', {
        from: 'accident',
        tar: 'baseForm',
      });
    },
    async sendDataToDetail () {
      await this.$emit('getOtherFormVal', {
        from: 'detailForm',
        tar: 'baseForm',
      });
    },
    async sendDataToReceipt () {
      await this.$emit('getOtherFormVal', {
        from: 'receipt',
        tar: 'baseForm',
      });
      await this.$emit('getOtherFormVal', {
        from: 'detailForm',
        tar: 'baseForm',
      });
      // 车辆租金要用到服务商信息，所以发送到详情那里去
      // this.sendDataToDetail();
    },
    async handleCostTypeChange (clear) {
      let costType = this.$refs.baseForm.getVal('costType');
      costType = Number(costType);
      // costType = Number(costType[costType.length - 1]);
      await this.sendDataToDetail();
      await this.sendDataToAccident();
      // 服务商
      const serviceShowType = [
        2005, // 年审费
        2006, // 保险费
        2008, // 违章费
        4015, // GPS
        2012, // 尿素
        2020, // 维护保养
        2002, // 车辆租金
        4016, // 导流罩
      ];
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: serviceShowType.indexOf(costType) === -1,
        names: ['chooseServerType'],
      });
      this.handleChooseServerTypeChange(clear);
      // 采购金额
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: costType !== 4016, // 导流罩
        names: ['purchaseFee'],
      });
      // 服务商数据处理
      switch (costType) {
        case 2008: // 违章费
          this.serviceType = 4;
          break;
        case 2006: // 保险费
          this.serviceType = 5;
          break;
        case 2005: // 年审费
          this.serviceType = 6;
          break;
        case 4015: // GPS
          this.serviceType = 7;
          break;
        case 2012: // 尿素
          this.serviceType = 8;
          break;
        case 2002: // 车辆租金
          this.serviceType = 9;
          break;
        default:
          break;
      }
      if (clear) {
        this.$refs.baseForm.setVal('servicer', {});
      }
    },
    handleChooseServerTypeChange (clear) {
      const vehicleFeeType = Number(this.$route.query.vehicleFeeType);
      if (vehicleFeeType === 3) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['car', 'driver'],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['costType'],
        });
        // 申请费用
        // 服务商选择还是输入的
        const chooseServerType = this.$refs.baseForm.getVal('chooseServerType');
        let costType = this.$refs.baseForm.getVal('costType');
        costType = Number(costType);
        // costType = Number(costType[costType.length - 1]);
        const serviceShowType = [
          2005, // 年审费
          2006, // 保险费
          2008, // 违章费
          4015, // GPS
          2012, // 尿素
          2002, // 车辆租金
          2020, // 维保
          4016, // 导流罩
        ];
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: chooseServerType === 0 || serviceShowType.indexOf(costType) === -1,
          names: ['servicer'],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: chooseServerType === 1 || serviceShowType.indexOf(costType) === -1,
          names: ['serviceName'],
        });
        if (clear) {
          this.$refs.baseForm.setVal('servicer', {});
          this.$refs.baseForm.setVal('serviceName', '');
        }
        this.sendDataToReceipt();
      } else if (vehicleFeeType === 1) {
        // 费用报销
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['costType'],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['car', 'driver', 'chooseServerType', 'servicer', 'serviceName'],
        });
      } else if (vehicleFeeType === 2) {
        // 订单费用报销
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['car', 'driver'],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['costType', 'chooseServerType', 'servicer', 'serviceName'],
        });
      }
    },

    async getList () {
      const vehicleFeeType = this.$route.query.vehicleFeeType;
      this.baseForm.costTypeOptions = await queryVehicleExpenseTypes({
        vehicleFeeType,
      });
      this.baseForm.orgIdOptions = await getDepartmentAllList();
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 服务商数据处理
        if (formData.chooseServerType === 1 && formData.servicer) {
          formData.serviceName = formData.servicer.serviceName;
          formData.serviceId = formData.servicer.serviceUserId;
          formData.servicePhone = formData.servicer.mobilePhone;
        }
        if (formData.driver && formData.driver.linkman) {
          formData.driverName = formData.driver.linkman;
        }
        if (formData.car && formData.car.plateNumber) {
          formData.plateNumber = formData.car.plateNumber;
          formData.licenceType = formData.car.licenceType;
          formData.licenceTypeName = formData.car.licenceTypeName;
        }
        delete formData.servicer;
        delete formData.driver;
        delete formData.car;
        // 费用类型
        // formData.costType = formData.costType[formData.costType.length - 1];
        // 费用归属日期
        // formData.feeAscriptionDate = this.formatDate(formData.feeAscriptionDate);
        formData.busiCode = this.busiCode;
        formData.applyTime = this.applyTime;
      }
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      if (!data.applyTime) {
        this.applyTime = this.formatDate(new Date(), 1);
      } else {
        this.applyTime = data.applyTime;
      }
      // if (data.feeAscriptionDate === undefined) {
      //   data.feeAscriptionDate = getPreOrNextToday();
      // }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id),
        names: ['costType'],
      });
      // 服务商
      if (data.serviceId) {
        data.chooseServerType = 1;
        data.servicer = {
          serviceName: data.serviceName,
          serviceUserId: data.serviceId,
          mobilePhone: data.servicePhone,
        };
      } else if (data.serviceName) {
        data.chooseServerType = 0;
      } else {
        data.chooseServerType = 1;
      }
      // 费用类型处理
      if (data.costType) {
        data.costType = String(data.costType);
      }
      // 司机姓名
      if (data.driverName) {
        data.driver = {
          linkman: data.driverName,
        };
      }
      // 车牌号码
      if (data.plateNumber) {
        data.car = {
          plateNumber: data.plateNumber,
          licenceType: data.licenceType,
          licenceTypeName: data.licenceTypeName,
        };
      }

      // if (!data.costType) {
      //   data.costType = [];
      // } else {
      // const costTypeOptions = this.baseForm.costTypeOptions;
      // const costType = [];
      // for (let i = 0; i < costTypeOptions.length; i++) {
      //   if (Number(costTypeOptions[i].value) === Number(data.costType)) {
      //     costType.push(Number(costTypeOptions[i].value));
      //     break;
      //   } else if (costTypeOptions[i].children && costTypeOptions[i].children.length !== 0) {
      //     for (let j = 0; j < costTypeOptions[i].children.length; j++) {
      //       if (Number(costTypeOptions[i].children[j].value) === Number(data.costType)) {
      //         costType.push(Number(costTypeOptions[i].value));
      //         costType.push(Number(costTypeOptions[i].children[j].value));
      //         break;
      //       }
      //     }
      //   }
      // }
      // data.costType = costType;
      // }

      if (!data.orgId) {
        if (this.baseForm.orgIdOptions.length) {
          // 默认设置为第一个
          data.orgId = this.baseForm.orgIdOptions[0].value;
        }
      }
      // 费用类型处理 end
      this.$refs.baseForm.setVal('form', data);
      this.busiCode = data.busiCode || '';
      await this.handleCostTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
.applyInfoLabel {
  margin-left: 16px;
}
.tip {
  margin-left: 8px;
}
</style>
